import { NavBar } from './navBar';
import { MovieGrid } from './MovieGrid';
import { GenreBar } from './GenreBar'
import { HomeCarousel } from './HomeCarousel'
import { Footer } from './Footer';
import { useSearchParams } from 'react-router-dom';

export const Home = () =>
{
      const [searchParams, setSearchParams] = useSearchParams()

      return <>
            <NavBar/>
            <HomeCarousel/>
            <GenreBar setSearchParams={setSearchParams} searchParams={searchParams}/>
            <MovieGrid searchParams={searchParams} setSearchParams={setSearchParams}/>
            <Footer />
      </>


}